<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="false" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.searchName')" prop="keywords">
            <BjInput v-model="queryParams.keywords" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.searchName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.group')" prop="group">
            <BjSelectLov v-model="groupData" multiple lov-code="BILL_CATEGORY_GROUP" @change="chooseGroups" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.department')" prop="department">
            <BjSelectLov v-model="departmentData" multiple :clearable="false" :option-list="departmentList" @change="chooseDepartment" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.position')" prop="position">
            <BjSelectLov v-model="positionData" multiple :clearable="false" :option-list="positionList" @change="choosePosition" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.template')" prop="template">
            <BjSelectLov v-model="queryParams.template" :clearable="false" :option-list="templateList" @change="handleQuery"/>
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.tag')" prop="tags">
            <BjSelectLov v-model="tagData" multiple :clearable="false" :option-list="tagsList" @change="chooseTags" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="createNew">{{ $t('billingPage.create') }}</el-button>
        </el-col>
      </template>
      <!-- 展示列表 -->
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <span v-else-if="col.prop === 'name'" class="link" @click="onView(scope.row)">
                {{ scope.row[col.prop] }}
              </span>
              <span v-else-if="['tag', 'templates', 'department'].includes(col.prop)">
                {{ scope.row[col.prop]?scope.row[col.prop].join(','):  scope.row[col.prop] }}
              </span>
              <span v-else-if="col.prop === 'position'">
                {{ JSON.parse(scope.row.position).join(',') }}
              </span>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren size="mini" @command="command($event, props.row)">
                <span class="el-dropdown-link">
                  {{ $t('AccountManagement.common.operate') }} <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- <el-dropdown-item v-if="props.row.state!='Running'" :command="1">{{ $t('billingPage.run') }}</el-dropdown-item>
                  <el-dropdown-item v-if="props.row.state=='Running'" :command="2">{{ $t('billingPage.stop') }}</el-dropdown-item> -->
                  <el-dropdown-item :command="3">{{ $t('editText') }}</el-dropdown-item>
                  <el-dropdown-item :command="4">{{ $t('delText') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @handleConfirm="handleConfirm" :positionList="positionList" :departmentList="departmentList"/>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from '@/api';
import DataForm from './components/DataForm.vue';
const defaultForm = () => {
  return {
    keywords: null,
    group: null,
    template: null,
    tags: null,
    department: null,
    position: null,
  }
}
export default {
  name: 'BusinessBillingCategories',
  components: {DataForm},
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      // 查询参数
      queryApi: billApi.getBillCategoryList,
      queryParams: defaultForm(),
      labelList: [
        { label: this.$t('billingPage.name'), prop: 'name', isCheck: true, disabled: false },
        { label: this.$t('billingPage.code'), prop: 'code', isCheck: true, disabled: false },
        { label: this.$t('billingPage.group'), prop: 'group', isCheck: true, disabled: false },
        { label: this.$t('billingPage.department'), prop: 'department', isCheck: true, disabled: false },
        { label: this.$t('billingPage.position'), prop: 'position', isCheck: true, disabled: false },
        { label: this.$t('billingPage.template'), prop: 'templates', isCheck: true, disabled: false },
        { label: this.$t('billingPage.tag'), prop: 'tag', isCheck: true, disabled: false },
        { label: this.$t('billingPage.lastUpdatedAt'), prop: 'gmtUpdate', isCheck: true, disabled: false },
        { label: this.$t('billingPage.description'), prop: 'description', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 140 },
      ],
      templateList:[],
      tagData: [],
      tagsList: [],
      groupData: [],
      positionData: [],
      departmentData: [],
      positionList: [],
      departmentList: []
    };
  },
  computed: {},
  created() {
    this.getTemplateList()
    this.getTagsList()
    this.getBillCategoryDepartments()
    this.getBillCategoryPositions()
  },
  methods: {
    command(val, item) {
      // if (val === 1) { this.goUp(item); }
      // if (val === 2) { this.goDown(item); }
      if (val === 3) { this.onEdit(item); }
      if (val === 4) { this.onDelete(item); }
    },
    // 获取模版列表
    getTemplateList() {
      billApi.getBillCategoryTemplate().then(e => {
        this.templateList = e.data
      });
    },
    // 获取标签列表
    getTagsList() {
      billApi.getBillCategoryTagsList().then(e => {
        this.tagsList = e.data
      });
    },
    getBillCategoryDepartments(){
      billApi.getBillCategoryDepartments().then(e => {
        this.departmentList = e.data
      });
    },
    getBillCategoryPositions(){
      billApi.getBillCategoryPositions().then(e => {
        e.data.forEach(item =>{
          item.percentage = ''
        })
        this.positionList = e.data
      });
    },
    chooseGroups(value){
      this.queryParams.group = value.join(',')
      this.handleQuery()
    },
    choosePosition(value){
      this.queryParams.position = value.join(',')
      this.handleQuery()
    },
    chooseDepartment(value){
      this.queryParams.department = value.join(',')
      this.handleQuery()
    },
    // 处理标签传参数据
    chooseTags(value){
      this.queryParams.tags = value.join(',')
      this.handleQuery()
    },
    // 新增
    createNew() {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 1;
        this.getBillCategoryPositions()
    },
    // 删除
    onDelete(item) {
        billApi.deleteBillCategoryList({id: item.id}).then(() => {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
        });
    },
    // 修改
    onEdit(row) {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 2;
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(row));
        this.$refs.DataForm.positionListName = (row.positionList.map(row=> row.name)).join(',')
        this.$refs.DataForm.checkList = row.positionList.map(row => row.name)
        this.positionList.forEach(item => {
          this.$set(item, 'percentage', '')
          row.positionList.forEach(jitem=>{
            if(item.label == jitem.name){
              this.$set(item, 'percentage', jitem.percentage)
            }
          })
        })
        this.$refs.DataForm.dataTagsList = row.tag ? row.tag : [];
    },
    // 查看
    onView(row) {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.openType = 3;
        this.$refs.DataForm.form = JSON.parse(JSON.stringify(row));
        this.$refs.DataForm.positionListName = (row.positionList.map(row=> row.name)).join(',')
        this.$refs.DataForm.checkList = row.positionList.map(row => row.name)
        this.positionList.forEach(item => {
          this.$set(item, 'percentage', '')
          row.positionList.forEach(jitem=>{
            if(item.label == jitem.name){
              this.$set(item, 'percentage', jitem.percentage)
            }
          })
        })
        this.$refs.DataForm.dataTagsList = row.tag ? row.tag : [];
    },
    // 启用  runBillCategory
    goUp(item) {
        // console.log(item, 'goUp');
        billApi.runBillCategory({id: item.id}).then(() => {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
    },
    // 停用  stopBillCategory
    goDown(item) {
        // console.log(item, 'goDown');
        billApi.stopBillCategory({id: item.id}).then(() => {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
    },

    // 子页面回调执行  '新增'  或者 '编辑' 方法
    handleConfirm(row) {
      // 判断逻辑 ==> id存在就是编辑，否则就是新增
      if (row.id) {
        billApi.updateBillCategoryList(row).then(() => {
          this.$refs.DataForm.handleClose();
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      } else {
        billApi.addBillCategoryList(row).then(() => {
          this.$refs.DataForm.handleClose();
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      }
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParams = defaultForm();
      this.groupData = [];
      this.departmentData = [];
      this.positionData = [];
      this.tagData =[];
      return new Promise(resolve => {
        resolve();
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
